// push notifications only available on native
export const PushNotifications = () => null;
